import { render } from "./paperAnswerSheet.vue?vue&type=template&id=2c9e48eb&scoped=true"
import script from "./paperAnswerSheet.vue?vue&type=script&lang=js"
export * from "./paperAnswerSheet.vue?vue&type=script&lang=js"

import "./paperAnswerSheet.vue?vue&type=style&index=0&id=2c9e48eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9e48eb"]])

export default __exports__